export class AiContentProvider {
  constructor() {}
}
